import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import JackpotLobbyComponent from "../Components/JackpotLobbyComponent";
interface QBLProps {
    atagParams: string | null,
    viewType: string | null,
    sourceParams: string | null,
    ticketOpenMode: string | null,
    botAccessToken?: string | null,
    botRefreshToken?: string | null,
}
const QuickbetLobby: FC <QBLProps> = ({atagParams, viewType, sourceParams, ticketOpenMode, botAccessToken, botRefreshToken}) => {
    const {getJackpotsData} = useAction();
    const {jackpotsData} = useTypedSelector((state) => state.jackpotsReducer);
    useEffect(()=>{
        getJackpotsData();
    }, [])
    return (
        <>
            {
                jackpotsData.length > 0 ?
                    <JackpotLobbyComponent
                        data={jackpotsData}
                        sourceParams={sourceParams}
                        atagParams={atagParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                        botAccessToken={botAccessToken}
                        botRefreshToken={botRefreshToken}
                    />
                    : null
            }
        </>
    );

}

export default QuickbetLobby;